<template lang="pug">
  section.solutions(id="solutions")
    h1(:class="titleAnimation") 应用场景
    div
      .card(v-for="(item, index) in nowOps.solutionsList"
        v-show="contentIsShow" :class="[contentAnimation, `animateDelay-${index}`, nowOps.solutionImages[index]]")
        h3 {{ item.title }}
        p(v-show="item.text") {{ item.text }}
</template>

<script>
  import Mixin from '../index.js'
  export default {
    name: "solutions",
    mixins: [Mixin],
  };
</script>

<style scoped lang="stylus">
  @import "../index.styl"
  .solutions {
    padding 100px 0
    VStack(center)
    > div {
      HStack(center, center)
      max-width 1660px
      .card {
        VStack(center, center)
        height 388px
        width 420px
        background-repeat no-repeat
        margin 0 20px
        transition all .3s
        background-color #2f2f2f
        background-size auto 100%
        &:hover {
          background-size auto 120%
        }
        h3, p {
          color white
        }
        h3 {
          //font-size (36 / 14)rem
          font-size 36px
          FontSetting("思源黑体")
          font-weight normal
        }
        p {
          font-size 16px
          line-height 22px
          FontSetting("思源黑体")
          font-weight 300
        }
      }
      .bigDataSolution-1, .aiSolution-1 {
        background url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E8%83%8C%E6%99%AF%E4%B8%AD%E5%9B%BE/%E6%95%B0%E5%AD%97%E5%9F%8E%E5%B8%82.png") no-repeat center
      }
      .bigDataSolution-2, .aiSolution-2, .Marketing-1 {
        background url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E8%83%8C%E6%99%AF%E4%B8%AD%E5%9B%BE/%E6%95%B0%E5%AD%97%E6%95%99%E8%82%B2.png") no-repeat center
      }
      
      .iotSolution-1 {
        background url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E8%83%8C%E6%99%AF%E4%B8%AD%E5%9B%BE/%E4%BA%BA%E8%84%B8%E8%AF%86%E5%88%AB.png") no-repeat center
      }
      .iotSolution-2 {
        background url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E8%83%8C%E6%99%AF%E4%B8%AD%E5%9B%BE/%E6%95%B0%E5%AD%97%E7%9B%91%E6%8E%A7.png") no-repeat center
      }
      .iotSolution-3 {
        background url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E8%83%8C%E6%99%AF%E4%B8%AD%E5%9B%BE/%E5%B7%A5%E4%B8%9A%E7%89%A9%E8%81%94%E7%BD%91.png") no-repeat center
      }
      
      .Marketing-2 {
        background url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E8%83%8C%E6%99%AF%E4%B8%AD%E5%9B%BE/%E6%95%B0%E5%AD%97%E6%97%85%E6%B8%B8.png") no-repeat center
      }
      
      .Marketing-3 {
        background url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E8%83%8C%E6%99%AF%E4%B8%AD%E5%9B%BE/%E6%95%B0%E5%AD%97%E5%8C%BB%E7%96%97.png") no-repeat center
      }
      
      .Recommendation-1 {
        background url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E8%83%8C%E6%99%AF%E4%B8%AD%E5%9B%BE/%E7%94%B5%E5%95%86%E6%8E%A8%E8%8D%90.png") no-repeat center
        flex-shrink 1
      }
      
      .Recommendation-2 {
        background url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E8%83%8C%E6%99%AF%E4%B8%AD%E5%9B%BE/%E9%87%91%E8%9E%8D%E6%8E%A8%E8%8D%90.png") no-repeat center
        flex-shrink 1
      }
      
      .Recommendation-3 {
        background url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E8%83%8C%E6%99%AF%E4%B8%AD%E5%9B%BE/%E6%96%B0%E9%97%BB%E8%B5%84%E8%AE%AF%E6%8E%A8%E8%8D%90.png") no-repeat center
        flex-shrink 1
      }
      
      .Recommendation-4 {
        background url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E8%83%8C%E6%99%AF%E4%B8%AD%E5%9B%BE/%E7%9F%AD%E8%A7%86%E9%A2%91%E6%8E%A8%E8%8D%90.png") no-repeat center
        flex-shrink 1
      }
      
    }
    @media (max-width ipadProScreenWidth) {
      > div {
        max-width 100vw
        overflow-x auto
        HStack(center)
        .card {
          flex-shrink 0
        }
      }
    }
    @media (max-width screenWidth) {
      padding 50px 0
      width 100vw
      h1 {
        margin-bottom 0
      }
      > div {
        width 100%
        overflow auto
        HStack()
        .card {
          width 253.2px
          height 232.8px
          flex-shrink 0
          h3 {
            font-size 24px
          }
          p {
            font-size 16px
            padding 10px
          }
        }
      }
    }
  }
</style>
